import React, { lazy, Suspense } from 'react';

import BaseLayout from 'ff/debrief/layouts/BaseLayout';
import Header from 'ff/debrief/components/Header';
import TwoDeeMap from 'ff/debrief/components/map/Map';
import ModalManager from 'ff/debrief/modalManager';
import { useMapSettings } from 'ff/debrief/hooks';
import { Outlet } from 'react-router';

const LazyThreeDeeMap = lazy(
    () => import('ff/debrief/components/map/3d/3DMap')
);
function ThreeDeeMap(props: React.PropsWithChildren<{}>) {
    return (
        <Suspense>
            <LazyThreeDeeMap>{props.children}</LazyThreeDeeMap>
        </Suspense>
    );
}

const MapGridLayout = () => {
    const { mapMode } = useMapSettings();
    const Map = mapMode === '3D' ? ThreeDeeMap : TwoDeeMap;
    return (
        <BaseLayout>
            <Header></Header>
            <Map>
                <Outlet />
            </Map>
            <ModalManager />
        </BaseLayout>
    );
};

export default MapGridLayout;
